import React from 'react';
import fieldConfig, { EXAMENES_SOLO_CONCLUSION } from '../config/fieldConfig';

const CAMPO_COMENTARIOS = [{ name: 'comentarios', label: 'Comentarios' }];

const CamposTiposExamenes = () => {
  return (
    <div className="campos-examenes-container">
      <div className="campos-examenes-grid">
        {Object.entries(fieldConfig).map(([tipo, campos]) => {
          const camposMostrados = EXAMENES_SOLO_CONCLUSION.includes(tipo) ? CAMPO_COMENTARIOS : campos;
          return (
            <div className="campos-examen-card" key={tipo}>
              <h4>{tipo}</h4>
              <ul>
                {camposMostrados.map(campo => (
                  <li key={campo.name}>{campo.label}</li>
                ))}
              </ul>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default CamposTiposExamenes;


